export const types = {
    SET_CURRENT_SLIDE: 'set_current_slide',
    UPDATE_CURRENT_SLIDE_INDEX: 'update_current_slide_index',
    UPDATE_SHAPE_POSITION: 'update_shape_position',
    UPDATE_SHAPE_SIZE: 'update_shape_size',
    UPDATE_SHAPE_ROTATION: 'update_shape_rotation',
    UPDATE_NON_RECTANGULAR_SHAPE: 'update_non_rectangular_shape',
    UPDATE_BUBBLE_CONTROL_POINT: 'update_bubble_control_point',
    SELECT_SHAPE: 'select_shape',
    CREATE_SHAPE: 'create_shape',
    DUPLICATE_SHAPE: 'duplicate_shape',
    DELETE_SHAPES: 'delete_shapes',
    LOCK_SHAPE: 'lock_shape',
    CHANGE_BACKGROUND_CONTENT: 'change_background_content',
    UPDATE_CURRENT_SLIDE_THUMBNAIL: 'udpate_current_slide_thumbnail',
    INIT_SLIDE: 'init_slide',
    BRING_TO_FRONT: 'bring_to_front',
    SEND_TO_BACK: 'send_to_back',
    BRING_FORWARD: 'bring_forward',
    SEND_BACKWARD: 'send_backward',
    CHANGE_FILTER: 'change_filter',
    CHANGE_SLIDE_DURATION: 'change_slide_duration',
    CHANGE_ALTERNATIVE_TEXT: 'change_alternative_text',
    CHANGE_STROKE_SIZE: 'change_stroke_size',
    CHANGE_SHAPE_OPACITY: 'change_shape_opacity',
    CHANGE_SHAPE_STROKE_OPACITY: 'change_shape_stroke_opacity',
    CHANGE_SHAPE_FILL_COLOR: 'change_shape_fill_color',
    CHANGE_SHAPE_STROKE_COLOR: 'change_shape_stroke_color',
    CHANGE_TEXT_PROPERTIES: 'change_text_properties',
    SET_SHORTCUTS_TARGET: 'set_shortcuts_target',
    MOVE_SHAPE: 'move_shape',
    UPDATE_TEXT_PROPERTIES: 'update_text_properties',
    SET_CLONE_TARGET: 'set_clone_target',
    CANVAS_UNDO_REDO_ACTION: 'canvas_undo_redo_action',
    CHANGE_MOOD: 'change_mood',
    SELECT_LAST_ADDED_SHAPE: 'select_last_added_shape',
    UPDATE_TEXT_HEIGHT: 'update_text_height',
    CHANGE_SHAPE_FILL_VISIBILITY: 'change_shape_fill_visibility',
    CHANGE_IS_NEW_SHAPE: 'change_is_new_shape',
    SET_SLIDE_SOUND: 'set_slide_sound',
    SET_SLIDE_SOUND_EFFECT: 'set_slide_sound_effect',
    CHANGE_INTERACTION_STATE: 'change_interaction_state',
    UPDATE_CURRENT_SLIDE_MOODS: 'update_current_slide_moods',
    OLD_TEXT_RESIZED: 'old_text_resized',
    UPDATE_IMAGE_HEIGHT: 'update_image_height',
    UPDATE_IMAGE_SIZE: 'update_image_size',
    UPDATE_IMAGE_SIZE_WHEN_CHANGE_MOOD: 'update_image_size_when_change_mood',
    UPDATE_HOTSPOT: 'update_hotspot',
    CHANGE_SHAPES_POSITION: 'change_shapes_position',
    SELECT_SHAPES_FROM_AREA: 'select_shape_from_area',
    CREATE_GROUP: 'create_group',
    UNGROUP: 'ungroup',
    CHANGE_VIDEO_PROPERTIES: 'change_video_properties',
    CHANGE_SLIDE_SOUND_VOLUME: 'change_slide_sound_volume',
    ADD_ANIMATION: 'add_animation',
    REMOVE_ANIMATION: 'remove_animation',
    ANIMATE: 'animate',
    UPDATE_CROPPING_HOTSPOT: 'update_cropping_hotspot',
    UPDATE_STEM: 'update_stem',
    CHANGE_SHAPE_TYPE: 'change_shape_type',
    CHANGE_RICH_TEXT_CONTENT: 'change_rich_text_content',
    CHANGE_TEXT_LINE_HEIGHT: 'change_text_line_height',
    CHANGE_FLIP: 'change_flip',
    INSERT_IMAGE_NODE: 'insert_image_node',
    ADD_VIDEO_SHAPE_DURATION: 'add_video_shape_duration',
    UPDATE_VIDEO_SHAPE: 'update_video_shape'
};

export function setCurrentSlide(currentSlideIndex) {
    return (dispatch, getState) => {
        const state = getState();
        const currentSlideModel = Object.assign({}, state.production.slides[currentSlideIndex]);
        dispatch({ type: types.SET_CURRENT_SLIDE, currentSlideIndex, currentSlideModel });
    };
}

export function updateShapePosition(uuid, newX, newY) {
    return { type: types.UPDATE_SHAPE_POSITION, uuid, newX, newY };
}

export function updateShapeSize(uuid, newWidth, newHeight, x, y, horizontalFlip, verticalFlip, cx, cy, cx1, cy1, cx2, cy2, cx3, cy3, cx4, cy4, cx5, cy5) {
    return { type: types.UPDATE_SHAPE_SIZE, uuid, newWidth, newHeight, x, y, horizontalFlip, verticalFlip, cx, cy, cx1, cy1, cx2, cy2, cx3, cy3, cx4, cy4, cx5, cy5 };
}

export function updateShapeRotation(uuid, newRotation) {
    return { type: types.UPDATE_SHAPE_ROTATION, uuid, newRotation};
}

export function updateNonRectangularShape(uuid, x1, y1, x2, y2, cx, cy) {
    return { type: types.UPDATE_NON_RECTANGULAR_SHAPE, uuid, x1, y1, x2, y2, cx, cy};
}

export function updateBubbleControlPoint(uuid, cx, cy, pointType = 'controlPoint') {
    return { type: types.UPDATE_BUBBLE_CONTROL_POINT, uuid, cx, cy, pointType};
}

export function selectShape(uuid, isNew) {
    return { type: types.SELECT_SHAPE, uuid, isNew};
}

export function createShape(shapeModel) {
    return { type: types.CREATE_SHAPE, shapeModel};
}

export function changeBackgroundContent(newContent) {
    return { type: types.CHANGE_BACKGROUND_CONTENT, newContent};
}

export function updateCurrentSlideThumbnail(value) {
    return { type: types.UPDATE_CURRENT_SLIDE_THUMBNAIL, value};
}

export function initSlide() {
    return { type: types.INIT_SLIDE};
}

export function duplicateShape(model) {
    return { type: types.DUPLICATE_SHAPE, model};
}

export function deleteShape(models) {
    return { type: types.DELETE_SHAPES, models};
}

export function addVideoShapeDuration(shapeModel, duration) {
    return { type: types.ADD_VIDEO_SHAPE_DURATION, shapeModel, duration};
}

export function updateVideoShape(uuid) {
    return { type: types.UPDATE_VIDEO_SHAPE, uuid};
}

export function lockShape(shapeModel) {
    return { type: types.LOCK_SHAPE, shapeModel};
}

export function bringToFront(shapeModel) {
    return { type: types.BRING_TO_FRONT, shapeModel};
}

export function sendToBack(shapeModel) {
    return { type: types.SEND_TO_BACK, shapeModel};
}

export function bringForward(shapeModel) {
    return {type: types.BRING_FORWARD, shapeModel};
}

export function sendBackward(shapeModel) {
    return { type: types.SEND_BACKWARD, shapeModel};
}

export function changeFilter(shapeModel, filter) {
    return { type: types.CHANGE_FILTER, shapeModel, filter};
}

export function changeSlideDuration(duration) {
    return { type: types.CHANGE_SLIDE_DURATION, duration};
}

export function changeAlternativeText(text) {
    return { type: types.CHANGE_ALTERNATIVE_TEXT, text};
}

export function changeStrokeSize(shapeModel, strokeSize) {
    return { type: types.CHANGE_STROKE_SIZE, shapeModel, strokeSize};
}

export function changeShapeOpacity(shapeModel, opacity) {
    return { type: types.CHANGE_SHAPE_OPACITY, shapeModel, opacity};
}

export function changeShapeStrokeOpacity(shapeModel, opacity) {
    return { type: types.CHANGE_SHAPE_STROKE_OPACITY, shapeModel, opacity};
}

export function changeShapeFillColor(shapeModel, color) {
    return { type: types.CHANGE_SHAPE_FILL_COLOR, shapeModel, color};
}

export function changeShapeStrokeColor(shapeModel, color) {
    return { type: types.CHANGE_SHAPE_STROKE_COLOR, shapeModel, color};
}

export function changeTextProperties(shapeModel, propertyType, newValue, isRichText) {
    return { type: types.CHANGE_TEXT_PROPERTIES, shapeModel, propertyType, newValue, isRichText};
}

export function setShortcutsTarget(isSlideCommand) {
    return { type: types.SET_SHORTCUTS_TARGET, isSlideCommand};
}

export function moveShape(uuid, offsetX, offsetY) {
    return { type: types.MOVE_SHAPE, uuid, offsetX, offsetY};
}

export function updateTextProperties(shapeModel, propertyType, stepOffset) {
    return { type: types.UPDATE_TEXT_PROPERTIES, shapeModel, propertyType, stepOffset};
}

export function setCloneTarget(shapeModel) {
    return { type: types.SET_CLONE_TARGET, shapeModel};
}

export function updateCurrentSlideIndex(slideUid) {
    return { type: types.UPDATE_CURRENT_SLIDE_INDEX, slideUid};
}

export function canvasUndoRedoAction(newState) {
    return { type: types.CANVAS_UNDO_REDO_ACTION, newState};
}

export function changeMood(uuid, frameLabel) {
    return { type: types.CHANGE_MOOD, uuid, frameLabel};
}

export function selectLastAddedShape() {
    return { type: types.SELECT_LAST_ADDED_SHAPE};
}

export function updateTextHeight(uuid, newHeight, newWidth) {
    return { type: types.UPDATE_TEXT_HEIGHT, uuid, newHeight, newWidth};
}

export function changeShapeFillVisibility(uuid, isFillVisible) {
    return { type: types.CHANGE_SHAPE_FILL_VISIBILITY, uuid, isFillVisible};
}

export function changeIsNewShape(uuid, isNew) {
    return { type: types.CHANGE_IS_NEW_SHAPE, uuid, isNew};
}

export function setSlideSound(sound) {
    return { type: types.SET_SLIDE_SOUND, sound};
}

export function setSlideSoundEffect(sound) {
    return { type: types.SET_SLIDE_SOUND_EFFECT, sound};
}

export function changeInteractionState(uuid, newState, moveState) {
    return { type: types.CHANGE_INTERACTION_STATE, uuid, newState, moveState};
}

export function updateCurrentSlideMoods() {
    return { type: types.UPDATE_CURRENT_SLIDE_MOODS};
}

export function oldTextResized(uuid) {
    return { type: types.OLD_TEXT_RESIZED, uuid};
}

export function updateImageHeight(uuid, newHeight, updateWidth) {
    return { type: types.UPDATE_IMAGE_HEIGHT, uuid, newHeight, updateWidth};
}

export function updateImageSize(uuid, newWidth, newHeight) {
    return { type: types.UPDATE_IMAGE_SIZE, uuid, newWidth, newHeight};
}

export function updateImageSizeWhenChangeMood(uuid, originalWidth, originalHeight) {
    return { type: types.UPDATE_IMAGE_SIZE_WHEN_CHANGE_MOOD, uuid, originalWidth, originalHeight};
}

export function updateHospot(uuid, hotspot) {
    return { type: types.UPDATE_HOTSPOT, uuid, hotspot};
}

export function updateCroppingHospot(uuid, hotspot) {
    return { type: types.UPDATE_CROPPING_HOTSPOT, uuid, hotspot};
}

export function changeShapesPosition(positions) {
    return { type: types.CHANGE_SHAPES_POSITION, positions};
}

export function selectShapeFromArea(selection) {
    return { type: types.SELECT_SHAPES_FROM_AREA, selection};
}

export function createGroup(groupModel) {
    return { type: types.CREATE_GROUP, groupModel};
}

export function ungroup(groupModel, shapes) {
    return { type: types.UNGROUP, groupModel, shapes};
}

export function changeVideoProperties(property, value) {
    return { type: types.CHANGE_VIDEO_PROPERTIES, property, value};
}

export function changeSlideSoundVolume(volume, isSoundEffect) {
    return { type: types.CHANGE_SLIDE_SOUND_VOLUME, volume, isSoundEffect};
}

export function addAnimation(uuid, animation) {
    return { type: types.ADD_ANIMATION, uuid, animation};
}

export function removeAnimation(uuid) {
    return { type: types.REMOVE_ANIMATION, uuid};
}

export function animate(shapes, animations) {
    return { type: types.ANIMATE, shapes, animations};
}

export function updateStem(uuid, value) {
    return { type: types.UPDATE_STEM, uuid, value};
}

export function changeShapeType(uuid, value) {
    return { type: types.CHANGE_SHAPE_TYPE, uuid, value};
}

export function changeRichTextContent(uuid, value) {
    return { type: types.CHANGE_RICH_TEXT_CONTENT, uuid, value};
}

export function changeTextLineHeight(uuid, value) {
    return { type: types.CHANGE_TEXT_LINE_HEIGHT, uuid, value};
}

export function changeFlip(uuid, flipType) {
    return { type: types.CHANGE_FLIP, uuid, flipType};
}

export function insertImageNode(uuid, href, aspectRatio) {
    return { type: types.INSERT_IMAGE_NODE, uuid, href, aspectRatio};
}


/** WEBPACK FOOTER **
 ** ./src/actions/CurrentSlideActions.js
 **/